import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createAction, createReducer } from '@infl-ts/util-redux-act';
import { useReducer } from 'react';
var defaultState = {
  activity: null,
  stage: null,
  open: false,
  challengeConfig: null
};
export var startNewActivity = createAction()('startNewActivity');
export var continueActivity = createAction()('continueActivity');
export var advanceToNextStage = createAction()('advanceToNextStage');
export var closeActivity = createAction('closeActivity');
export var openActivity = createAction()('openActivity');
export var destroyConfig = createAction('destroyConfig');
var challengeReducer = createReducer(defaultState).on(startNewActivity, function (state, payload) {
  var _state$challengeConfi;

  return _objectSpread(_objectSpread({}, state), {}, {
    challengeConfig: (_state$challengeConfi = state.challengeConfig) !== null && _state$challengeConfi !== void 0 && _state$challengeConfi.uuid ? _objectSpread(_objectSpread({}, state.challengeConfig), {}, {
      activity: 'new'
    }) : null,
    activity: null,
    stage: payload,
    open: true
  });
}).on(continueActivity, function (state, payload) {
  var _state$challengeConfi2;

  return _objectSpread(_objectSpread({}, state), {}, {
    challengeConfig: (_state$challengeConfi2 = state.challengeConfig) !== null && _state$challengeConfi2 !== void 0 && _state$challengeConfi2.uuid ? _objectSpread(_objectSpread({}, state.challengeConfig), {}, {
      activity: payload === null || payload === void 0 ? void 0 : payload.id
    }) : null,
    activity: payload,
    stage: payload ? payload.currentStage : null,
    open: true
  });
}).on(advanceToNextStage, function (state, payload) {
  var _state$challengeConfi3;

  return _objectSpread(_objectSpread({}, state), {}, {
    challengeConfig: (_state$challengeConfi3 = state.challengeConfig) !== null && _state$challengeConfi3 !== void 0 && _state$challengeConfi3.uuid ? _objectSpread(_objectSpread({}, state.challengeConfig), {}, {
      activity: payload === null || payload === void 0 ? void 0 : payload.id
    }) : null,
    activity: payload,
    stage: payload ? payload.currentStage : null
  });
}).on(closeActivity, function (_ref) {
  var challengeConfig = _ref.challengeConfig;
  return _objectSpread(_objectSpread({}, defaultState), {}, {
    challengeConfig: challengeConfig ? _objectSpread(_objectSpread({}, challengeConfig), {}, {
      activity: undefined
    }) : null
  });
}).on(destroyConfig, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    challengeConfig: null
  });
}).on(openActivity, function (_state, payload) {
  return {
    activity: null,
    stage: null,
    open: true,
    challengeConfig: payload
  };
});
export var useChallengeReducer = function useChallengeReducer() {
  return useReducer(challengeReducer, defaultState);
};